import { Injectable } from '@angular/core';
import { Branding, BrandingAccess } from '@rx-applications/shared/branding/utils';
import { RoomexBrandingAccessService } from './roomex-branding-access.service';
import { CorpayLodgingBrandingAccessService } from './corpaylodging-branding-access.service';

@Injectable({
  providedIn: 'root',
})
export class AppearanceStrategyFactoryService {
  private readonly appearances = new Map<Branding, BrandingAccess>([
    [Branding.RoomexBrand, new RoomexBrandingAccessService()],
    [Branding.CorpayLodgingBrand, new CorpayLodgingBrandingAccessService()],
  ]);

  getAppearance(branding: Branding): BrandingAccess {
    if (!this.appearances.has(branding)) {
      throw new Error(`Appearance not configured for branding: ${branding}`);
    }
    return this.appearances.get(branding)!;
  }
}
